<!--  crud table -->
<template>
  <v-container id="crud" :class="objCls">
    <Loading />
    <v-card outlined flat>
      <!-- TOOLBAR -->
      <v-toolbar flat>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              @click="onNewItem"
              :disabled="loading"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          {{ title }} 추가
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              @click="getList"
              :disabled="loading"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          새로고침
        </v-tooltip>
      </v-toolbar>

      <SearchForm v-if="objInfo.search" @search="onSearch" @reset="onReset" />

      <!-- TABLE -->
      <div class="pa-4">
        <v-data-table
          :headers="headers"
          :items="rows"
          :loading="loading"
          loading-text="데이터를 불러오는 중입니다"
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr class="clickable-row ma-0">
              <template v-for="(header, index) in headers">
                <!-- TYPE ACTION -->
                <td :key="index" v-if="header.type === 'action'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        icon
                        small
                        @click="onDetail(props.item)"
                        :disabled="loading"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    상세보기
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        icon
                        small
                        @click="onDeleteConfirm(props.item)"
                        :disabled="loading"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    삭제
                  </v-tooltip>
                </td>
                <!-- TYPE CHIP -->
                <td :key="index" v-else-if="header.type === 'chip'">
                  <v-chip
                    label
                    dark
                    small
                    :color="getColor(props.item[header.value])"
                  >
                    {{ props.item[header.value] }}
                  </v-chip>
                </td>
                <td :key="index" v-else-if="header.type === 'select'">
                  {{ props.item[header.select.ref] }}
                </td>
                <!-- TYPE OTHERS -->
                <td :key="index" v-else>
                  {{ header.chip }}
                  {{ props.item[header.value] | dataFilter(header, objNm) }}
                </td>
              </template>
            </tr>
          </template>
          <!-- NO DATA -->
          <template v-slot:no-data>
            <div class="py-4">
              <p class="black--text">데이터가 없습니다</p>
              <v-btn color="primary" outlined @click="initialize">
                <v-icon left>mdi-refresh</v-icon>
                새로고침
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>

      <!-- PAGINATION -->
      <div class="text-center py-2">
        <v-pagination
          v-model="page"
          :length="totalPage"
          :total-visible="9"
          @input="onInput"
        >
        </v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="deleteDlg" max-width="540" persistent>
      <v-card>
        <v-card-title class="font-weight-regular"> 삭제 </v-card-title>
        <v-card-text>
          <p class="mb-0">해당 아이템을 삭제하시겠습니까?</p>
          <p class="mb-0">UID: {{ sendKey }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteDlg = false"> 아니오 </v-btn>
          <v-btn color="primary" text @click="onDeleteItem"> 네 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/**
 * Table
 * 호춯 순서.
 * created...
 *
 *   params 의 객체명 과 page 값을 가지고 온다. (인자가 없으면 1)
 *
 *
 *
 */
import _ from "lodash";
import { mapGetters } from "vuex";

import { STORE } from "@/constants";
import CommonMixin from "@/mixins/common.mixin";

import { AdminAPI } from "@/api";
import crudUtil from "./crud_util";

import SearchForm from "@/components/common/SearchForm";
import Loading from "@/components/common/Loading";

export default {
  components: {
    SearchForm,
    Loading,
  },

  mixins: [CommonMixin],

  data() {
    return {
      searchText: null,
      searchField: null,
      page: 1, // current page
      totalPage: 1, // total page
      totalCount: 0, // item count
      itemsPerPage: 10, // items per page  in table
      options: null, // search optiuon
      sendKey: null,

      headers: [], // header item
      page: 0,
      rows: [],
      // objInfo: null,
      deleteDlg: false,
      search: {},
    };
  },
  computed: {
    objCls() {
      return this.objNm.toLowerCase();
    },

    objNm() {
      return this.$route.params.objNm;
    },

    title() {
      return this.objInfo.title;
    },

    _page() {
      return this.$route.params.page;
    },

    ...mapGetters({
      objInfo: `${STORE.ADMIN.NAME}/${STORE.ADMIN.OBJ_INFO}`,
      _rows: `${STORE.ADMIN.NAME}/${STORE.ADMIN.ROWS}`,
      _count: `${STORE.ADMIN.NAME}/${STORE.ADMIN.COUNT}`,
    }),
  },
  //page created
  created() {
    this.initialize();
  },
  // data filter
  filters: {
    dataFilter: crudUtil.dataFilter,
  },

  watch: {
    $route() {
      this.initialize();
    },
  },

  methods: {
    // select 객체의 text 를 가져온다.
    async selectText(model, uid) {
      console.log(model, uid);
      try {
        const item = await this.$store.dispatch(
          `${STORE.ADMIN.NAME}/${STORE.ADMIN.GET_OBJ}`,
          {
            objNm: model.select.obj,
            uid: uid,
          }
        );
        return item;
      } catch (err) {
        return "xxx";
      }
    },
    getColor(value) {
      if (value == "ok" || value == "connected") return "green";
      else return "red";
    },

    // create 이후 초기화
    async initialize() {
      this.page = this._page ? Number(this._page) : 1;
      this.rows = [];
      this.search = {};

      //  정보를 가지고 온다.
      this.setLoading(true);
      try {
        await this.$store.dispatch(
          `${STORE.ADMIN.NAME}/${STORE.ADMIN.OBJ_INFO}`,
          this.objNm
        );

        await this.makeHeader();
        await this.getList();
      } catch (e) {
        console.log(e);
      } finally {
        this.setLoading(false);
        this.goto(this.page);
      }
    },

    // 헤더 생성
    async makeHeader() {
      const headers = [];

      _.each(this.objInfo.fields, (item) => {
        if (item.hide || item.hideList) return;
        const header = {
          text: item.dispName
            ? item.dispName
            : item.text
            ? item.text
            : item.key,
          value: item.key,
          type: item.type,
          name: item.name,
          select: item.select,
          sortable: false,
          align: "left", //'center'
        };

        headers.push(header);
      });

      headers.push({
        text: "",
        type: "action",
        value: "action",
      });

      this.headers = [...headers];
      this.searchField = headers.length > 0 ? headers[0].value : "";
    },

    /**
     * 데이타 요청
     * crud.list 의 요청의 결과로 건수가 함께 되돌려진다.
     * 되돌려진 자료는  state의 rows 와 count 에 저장된다.
     *
     */
    async getList() {
      try {
        await this.$store.dispatch(`${STORE.ADMIN.NAME}/${STORE.ADMIN.LIST}`, {
          objNm: this.objNm,
          page: this.page,
          perpage: this.itemsPerPage,
          search: this.search,
        });

        this.rows = this._rows[this.objNm];

        this.totalPage = Math.ceil(this._count[this.objNm] / this.itemsPerPage);
      } catch (e) {
        throw new Error(e);
      }
    },
    /**
     * page 이동
     */
    goto(page) {
      if (this._page === page) {
        return false;
      }

      this.$route.params.page = page;

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          t: new Date().getTime(),
        },
      });
    },

    onInput(page) {
      this.goto(page);
    },

    onNewItem() {
      this.$router.push({
        name: "newObj",
        params: {
          objNm: this.objNm,
        },
      });
    },

    onDetail(item) {
      const sendKey = item[this.objInfo.uid];

      this.$router.push({
        name: "detailObj",
        params: {
          objNm: this.objNm,
          uid: sendKey,
        },
      });
    },

    editItem(item) {
      const sendKey = item[this.objInfo.uid];

      this.$router.push({
        name: "editObj",
        params: {
          objNm: this.objNm,
          uid: sendKey,
        },
      });
    },

    onDeleteConfirm(item) {
      this.sendKey = item[this.objInfo.uid];
      this.deleteDlg = true;
    },

    /**
     * 삭제 FORM
     */
    async onDeleteItem() {
      try {
        this.setLoading(true);
        const result = await AdminAPI.delete({
          objNm: this.objNm,
          uid: this.sendKey,
        });
        console.log("deleteItem", result);
        await this.getList();
      } catch (e) {
        console.log(e);
      } finally {
        this.sendKey = null;
        this.deleteDlg = false;
        this.setLoading(false);
      }
    },

    onSearch(v) {
      this.search = { ...v };
      this.page = 1;
      this.getList();
    },

    onReset() {
      this.search = {};
      this.page = 1;
      this.getList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/Table.vue